import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import defaultAvatar from 'assets/img/team/avatar.png';
import Avatar from 'components/common/Avatar';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfirmationModal from 'components/common/ConfirmationModal';
import DirectoryService from './DirectoryService';
import './ColleagueCard.css';

const ColleagueCard = ({
  colleague,
  linkToProfile = '/social/directory/user-details',
  onDelete
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const { avatar, firstName, email, lastName, identifier, roles } = colleague;
  const avatarSrc = avatar;
  const userRoles =
    roles && roles.length > 0
      ? roles.map(role => role.key)
      : 'No role assigned';
  const updatedLink = linkToProfile + '/' + identifier;
  const canDelete =
    DirectoryService.isLoggedUserRoot() || DirectoryService.isLoggedByAdmin();

  const handleConfirmDelete = () => {
    DirectoryService.deleteUserProfile(identifier)
      .then(value => {
        console.log(value);
        if (onDelete) {
          onDelete(identifier);
        }
      })
      .catch(error => console.error(error));
  };

  return (
    <Card className="w-100 h-100 position-relative">
      {canDelete && (
        <>
          <FontAwesomeIcon
            icon="trash-alt"
            className="text-danger position-absolute top-0 end-0 m-2"
            style={{ cursor: 'pointer', zIndex: 1 }}
            onClick={() => setShowConfirmModal(true)}
          />
          <ConfirmationModal
            show={showConfirmModal}
            onHide={() => setShowConfirmModal(false)}
            onConfirm={handleConfirmDelete}
            title="Delete user"
            message={`Are you sure to delete this user${
              firstName ? ` (${firstName} ${lastName})` : ''
            }?`}
            confirmLabel="Delete"
          />
        </>
      )}
      <Card.Body>
        <Link to={updatedLink}>
          <Avatar
            size="4xl"
            className="avatar-profile avatar-colleague-card"
            src={avatarSrc ? avatarSrc : defaultAvatar}
            mediaClass="img-thumbnail shadow-sm"
          />
        </Link>
      </Card.Body>
      <Card.Footer className="p-1 pb-4">
        <h6 className="mb-1">
          <Link to={updatedLink}>
            {firstName} {lastName}
          </Link>
        </h6>
        <p className="fs--2 mb-1">
          <b>
            {Array.isArray(userRoles) && userRoles.length > 0
              ? userRoles.join(', ')
              : userRoles || 'No role assigned'}
          </b>
          <br />
          <Link className="text-700" to={'mailto:' + email}>
            {email}
          </Link>
        </p>
      </Card.Footer>
    </Card>
  );
};

ColleagueCard.propTypes = {
  colleague: PropTypes.shape({
    avatar: PropTypes.any,
    avatarSrc: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    identifier: PropTypes.string,
    lastName: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string)
  }),
  linkToProfile: PropTypes.string,
  onDelete: PropTypes.func
};

export default ColleagueCard;
